import { SceneType } from 'types/Scene';
import { getFile } from 'utils/fileCache';
import { PREVIEW_DIMENSION } from 'constants/projects';

const projectPreviewCash: { [key: string]: string } = {};

const createVideo = (src: string): Promise<HTMLVideoElement> =>
  new Promise(resolve => {
    const video = document.createElement('video');
    video.onloadeddata = () => resolve(video);
    video.src = src;
    video.width = PREVIEW_DIMENSION;
    video.height = PREVIEW_DIMENSION;
    video.crossOrigin = 'Anonymous';
    video.style.objectFit = 'cover';
    video.autoplay = true;
    video.muted = true;
  });

const getVideoDataUrl = (video: HTMLVideoElement): Promise<string> =>
  new Promise(resolve => {
    video.play().then(() => {
      const canvas = document.createElement('canvas');
      canvas.width = PREVIEW_DIMENSION;
      canvas.height = PREVIEW_DIMENSION;
      const vidRatio = video.videoWidth / video.videoHeight;
      const videoWidth = vidRatio < 1 ? canvas.width : canvas.height * vidRatio;
      const videoHeight = vidRatio < 1 ? canvas.width / vidRatio : canvas.height;
      canvas
        .getContext('2d')
        .drawImage(
          video,
          (canvas.width - videoWidth) / 2,
          (canvas.height - videoHeight) / 2,
          videoWidth,
          videoHeight
        );
      const dU = canvas.toDataURL();
      video.pause();
      resolve(dU);
    });
  });

export const getVideoPreview = async (src: string): Promise<string> => {
  const videoSrc = await getFile(src);
  const video = await createVideo(videoSrc);
  const dataUrl = await getVideoDataUrl(video);
  return dataUrl;
};

export const getImagePreview = (src: string): Promise<string> => {
  return new Promise(resolve => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = PREVIEW_DIMENSION;
      canvas.width = PREVIEW_DIMENSION;
      const imgRatio = img.naturalWidth / img.naturalHeight;
      const imgWidth = imgRatio < 1 ? canvas.width : canvas.height * imgRatio;
      const imgHeight = imgRatio < 1 ? canvas.width / imgRatio : canvas.height;
      ctx.drawImage(
        img,
        (canvas.width - imgWidth) / 2,
        (canvas.height - imgHeight) / 2,
        imgWidth,
        imgHeight
      );
      const dataURL = canvas.toDataURL();
      resolve(dataURL);
    };
    img.src = src;
  });
};

export const getPreview = async (src: string, type: SceneType.VIDEO | SceneType.IMAGE) => {
  const cachedPreview = projectPreviewCash[src];
  if (cachedPreview) return cachedPreview;
  const preview =
    type === SceneType.VIDEO ? await getVideoPreview(src) : await getImagePreview(src);
  projectPreviewCash[src] = preview;
  return preview;
};
